import styled from 'styled-components';

const sizeMap = {
  default: 32,
  small: 28,
};

export const PillWrapper = styled.div`
  display: inline-flex;
  font-size: 14px;
  height: ${p => sizeMap[p.size]}px;
  font-family: ${p => p.theme.fonts.gtEesti};
  background-color: ${p =>
    p.type === 'dark' ? p.theme.colors.secondary40w : p.theme.colors.secondary95w};
  color: ${p => (p.type === 'dark' ? p.theme.colors.white : p.theme.colors.black)};
  border-radius: 8px;
  align-items: center;
  margin: ${p => (p.noMargin ? 0 : '5px 10px 5px 0')};
  padding: 0 10px;
  white-space: nowrap;
`;
